import React from 'react'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import HeroImgProject from '../components/HeroImgProject'
import Certificates from '../components/certficates/certficates'
import Work from '../components/Work'

const Project = () => {
  return (
    <div>
      <Navbar />
      <HeroImgProject heading="PROJECTS" text="Some of my recent works"/>
      <Work />
      <Certificates />
      <Footer />
    </div>
  )
}

export default Project